import PageContentLoader from "../TableLoader";

export default function Spinner({ message = "Loading..." }) {
  return <PageContentLoader message={message} />;
}
